import { number, object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  status: string().oneOf(['pending', 'completed', 'failed', 'in_progress']).required(),
  message: string().required(),
  success_count: number().required().integer().default(0),
  failure_count: number().required().integer().default(0),
  total_count: number().required().integer().default(0),
});

/**
 * BulkActionCreateEvent
 *
 * - Evento emitido quando uma ação em massa gera um log novo.
 */
export class BulkActionLogCreateEvent extends CreateCommand(RealtimeEventType.BulkActionLogCreate, SCHEMA) {}
